import { createContext } from 'react';

/** The app's parlay opener (useNotificationLink), so the header's notification bell can open a card's parlay. */
export const OpenParlayContext = createContext<((parlayId: number) => void) | null>(null);
